module.exports = __webpack_public_path__ + "static/img/bdzy-homePage.30ea9d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/beidaziyuan/bdzy-homePage.jpg
// module id = LC1H
// module chunks = 0